import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CommonService } from "src/app/services/common.service";

@Component({
  selector: "app-agent-badge",
  templateUrl: "./agent-badge.component.html",
})
export class AgentBadgeComponent implements OnInit {
  agentData: any;

  constructor(
    private route: ActivatedRoute,
    private commonService: CommonService,
  ) {}

  ngOnInit() {
    const uid = this.route.snapshot.queryParamMap.get("uid");
    const candidateAgentId =
      this.route.snapshot.queryParamMap.get("candidate_agent_id");

    if (uid && candidateAgentId) {
      this.loadAgent(uid, candidateAgentId);
    }
  }

  loadAgent(uid: any, candidateAgentId: any) {
    this.commonService
      .postCall("ElectionCandidateBiodata/GetAgentDetailsForBarcode", {
        agent1_user_id: uid,
        candidate_agent_id: candidateAgentId,
      })
      .subscribe((res: any) => {
        this.agentData = res;
      });
  }
}
